import React from 'react'
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { Link, } from 'react-router-dom';

export default function LastTransactionHistory() {
    const [transactionHistory, settransactionHistory] = useState([])


    useEffect(() => {
        const getTransactionHistory = async () => {
            try {
                const res = await Axios.post(`api/business/last-transaction-history`)
                settransactionHistory(res?.data?.data?.[0] || [])
            } catch (error) {
                console.error("Error fetching transaction history:", error);
                settransactionHistory([]);
            }

        };
        getTransactionHistory();
    }, []);

    const LastTransactions = (Array.isArray(transactionHistory) ? transactionHistory : []).slice(0, 10).map((item, index) => {

        return (
            <li key={index}>
                <i className=""></i>
                <span className="" style={{ padding: "10px", marginRight: '20px' }}>{item.business_name}</span>
                <span className="" style={{ marginRight: '25px' }}>{item.package_name}</span>
                <span className="" style={{ marginRight: '25px' }}>{item.added_date}</span>
                <span className="float-right text-success tran-price">{item.price}</span>
                <span className="clearfix"></span>
            </li>

        )
    })

    return (
        <>
            {LastTransactions}
            
                <Link to="/LetestRchargeStatus">
                    <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter" value={''}>View More</button>
                </Link>
            
            
        </>
    )
}
